// Copyright (c) 2016 Deere & Company

import Transfers, {getDefaultState} from '../state/transfers';
import actions from '../../actions-list';

const updateTransferStatus = (state, action) => {

    /* eslint-disable array-callback-return, consistent-return */

    const updatedTransfers = state.filter(transfer => {

        if (transfer.id !== action.data.id) {

            return transfer;

        }

    });

    /* eslint-enable array-callback-return, consistent-return */

    return Transfers.update(state, {
        $set: updatedTransfers
    });

};

const updateTransferComment = (state, action) => {

    const updatedTransfers = [...state];

    const index = state.findIndex(transfer =>
        transfer.id === action.data.id
    );

    if (index === -1) {

        return state;

    }

    updatedTransfers.splice(index, 1, action.data);

    return Transfers.update(state, {
        $set: updatedTransfers
    });

};

const updateTransferResults = (state, action) =>
    Transfers.update(state, {
        $set: action.data
    });

const updateTransferRejectedReason = (state, action) => {

    const updatedTransfers = [...state];

    const index = state.findIndex(transfer =>
            transfer.id === action.data.id
        );

    if (index === -1) {

        return state;

    }

    updatedTransfers.splice(index, 1, action.data);

    return Transfers.update(state, {
        $set: updatedTransfers
    });

};

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_TRANSFER_COMMENT_SUCCESS]: updateTransferComment,
        [actions.UPDATE_TRANSFER_RESULTS]: updateTransferResults,
        [actions.UPDATE_TRANSFER_STATUS_SUCCESS]: updateTransferStatus,
        [actions.UPDATE_TRANSFER_REJECTED_REASON]: updateTransferRejectedReason
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/transfers/reducers/transfers.js